import React, { useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@material-ui/core";
import { green, grey, red } from "@material-ui/core/colors";
import { getPercentageChange, VariationTable } from "../../pages/Dashboard";
import { ImgCotacao } from "../Feed/CotacaoInfo";
import { Watermark } from "./Contratos";
import mixpanel from "@utils/mixpanel/mixpanel.js";
import { RELATORIO_ICE_STOCKS_LONDRES } from "../../utils/mixpanel/mixpanelEvents";
import ReactECharts from "echarts-for-react";

export default function IceStocksRobusta({ iceReports }) {
  useEffect(() => {
    mixpanel.track(RELATORIO_ICE_STOCKS_LONDRES);
  }, []);

  return (
    <>
      <TableContainer
        component={Paper}
        style={{ marginTop: 40, maxWidth: 500, position: "relative" }}
      >
        <Watermark isSmall />
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>
                <div
                  style={{
                    display: "flex",
                    gap: 4,
                    alignItems: "center",
                  }}
                >
                  <ImgCotacao isLondres />
                  ICE Stocks Londres
                </div>
              </TableCell>
              <TableCell style={{ textAlign: "right" }}>Total Sacos</TableCell>
              <TableCell style={{ textAlign: "right" }}>Variação Dia</TableCell>
              <TableCell style={{ textAlign: "center" }}>%</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {iceReports?.map((row, index) => {
              const next = iceReports[index + 1];

              // % de variação
              const bagsChange = next
                ? getPercentageChange(
                    row.totalBagsRobusta,
                    next.totalBagsRobusta,
                  )
                : null;

              // Diferença em quantidade
              const bagsDiff =
                next &&
                row.totalBagsRobusta != null &&
                next.totalBagsRobusta != null
                  ? row.totalBagsRobusta - next.totalBagsRobusta
                  : null;

              const getColor = (val) => {
                if (val == null) return undefined;
                return parseFloat(val) < 0 ? red[400] : green[500];
              };

              if (!row?.totalBagsRobusta) return null;

              return (
                <TableRow key={`robusta-${row._id}`}>
                  <TableCell>
                    {new Date(row.createdAt).toLocaleString("pt-BR", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",
                    })}
                  </TableCell>

                  <TableCell style={{ textAlign: "right" }}>
                    {row.totalBagsRobusta?.toLocaleString() ?? "—"}
                  </TableCell>

                  <TableCell
                    style={{
                      color: getColor(bagsDiff),
                      fontWeight: "bold",
                      textAlign: "right",
                    }}
                  >
                    {bagsDiff != null
                      ? (bagsDiff > 0 ? "+" : "") + bagsDiff.toLocaleString()
                      : "—"}
                  </TableCell>

                  <TableCell
                    style={{
                      color: getColor(bagsChange),
                      paddingLeft: 12,
                    }}
                  >
                    {bagsChange != null ? `${bagsChange}%` : "—"}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <VariationTable iceReports={iceReports} isRobusta />
      <div style={{ height: 40 }} />
      <EChartsGradingChartRobusta data={iceReports} />
    </>
  );
}

function EChartsGradingChartRobusta({ data }) {
  let xData = [...data].reverse();
  const formattedDates = xData?.map((item) => {
    const d = new Date(item.createdAt);
    return `${String(d.getDate()).padStart(2, "0")}-${String(
      d.getMonth() + 1,
    ).padStart(2, "0")}-${d.getFullYear()}`;
  });

  const BLUE = "#6ecaff";
  const GRAY = grey[400];

  const option = {
    title: {
      text: `Total Sacos Robusta`,
      left: "center",
      textStyle: { color: GRAY },
    },
    tooltip: { trigger: "axis" },
    legend: {
      top: 30,
      data: ["Certificados Robusta"],
      textStyle: { color: GRAY },
    },
    xAxis: { type: "category", data: formattedDates },
    yAxis: {
      type: "value",
      name: "Total Sacos Robusta",
      position: "left",
      axisLine: { lineStyle: { color: BLUE } },
      axisLabel: { formatter: "{value}" },
    },
    series: [
      {
        name: "Certificados Robusta",
        type: "line",
        data: xData.map((d) =>
          d.totalBagsRobusta === 0 ? null : d.totalBagsRobusta,
        ),
        color: BLUE,
        connectNulls: true,
        smooth: true,
      },
    ],
    grid: { left: "10%", right: "10%", bottom: "15%" },
    toolbox: { feature: { saveAsImage: {}, dataZoom: {}, restore: {} } },
    dataZoom: [{ type: "slider", start: 0, end: 100 }],

    graphic: {
      elements: [
        {
          type: "text",
          left: "center",
          top: "center",
          style: {
            text: "cafetrade.com.br",
            fontSize: 30,
            fontWeight: "bold",
            fill: "rgba(200, 200, 200, 0.3)",
          },
          z: -10,
        },
      ],
    },
  };

  return (
    <ReactECharts option={option} style={{ height: "700px", width: "100%" }} />
  );
}
